var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useMutation } from '@tanstack/react-query';
import ENDPOINTS from '../../const/endpoints';
import { fetchConfig } from '../../helpers';
import { ExecutionCacheKey } from './execution-cache-key';
function useExecutionMutation(_a) {
    var config = _a.config, keyProps = _a.keyProps, _b = _a.mutationOptions, mutationOptions = _b === void 0 ? {} : _b;
    var fetchWrapper = fetchConfig(config);
    return useMutation(__assign({ mutationKey: ExecutionCacheKey(keyProps), mutationFn: function () {
            return fetchWrapper(ENDPOINTS.refundExecution, {
                method: 'POST',
                body: JSON.stringify({
                    'cipher.accountId': keyProps.accountId,
                    accountIdType: keyProps.accountIdType
                })
            });
        } }, mutationOptions));
}
export default useExecutionMutation;
